"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/no-cycle, camelcase */
var fetchApi_1 = __importDefault(require("../../rest/fetchApi"));
var loginApi_1 = require("../mock/loginApi");
var combinePlatformUrl_1 = __importDefault(require("./combinePlatformUrl"));
var combineLearningPanelFreeUrl_1 = __importDefault(require("./learningPanelFree/combineLearningPanelFreeUrl"));
var LoginAPI = {
    postLogin: function (body) {
        return fetchApi_1.default.post({
            mockFunc: function () { return ({ json: __assign(__assign({}, loginApi_1.successfulResponse), { role: 'user' }) }); },
            url: (0, combinePlatformUrl_1.default)('/users/sign_in'),
            body: body,
            returnResponse: true,
        });
    },
    logout: function () {
        return fetchApi_1.default.delete({
            mockFunc: function () { return loginApi_1.successfulResponse; },
            url: (0, combinePlatformUrl_1.default)('/users/sign_out'),
        });
    },
    getUserInfo: function () {
        return fetchApi_1.default.get({
            mockFunc: function () { return loginApi_1.userData; },
            url: (0, combinePlatformUrl_1.default)('/user'),
        });
    },
    signUp: function (body) {
        return fetchApi_1.default.post({
            mockFunc: function () { return loginApi_1.successfulResponse; },
            url: (0, combinePlatformUrl_1.default)('/users/self-registration'),
            body: body,
            returnResponse: true,
        });
    },
    signUpPLG: function (body) {
        return fetchApi_1.default.post({
            mockFunc: function () { return loginApi_1.successfulResponse; },
            url: (0, combinePlatformUrl_1.default)('/users'),
            body: body,
            returnResponse: true,
        });
    },
    setNickname: function (body) {
        return fetchApi_1.default.put({
            mockFunc: function () { return loginApi_1.successfulResponse; },
            url: (0, combinePlatformUrl_1.default)("/users/".concat(body === null || body === void 0 ? void 0 : body.token, "/set-nickname")),
            body: body,
        });
    },
    getUploadProfileUrl: function (token, filename) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.get({
                    mockFunc: function () { return console.log('getUploadProfileUrl'); },
                    url: (0, combinePlatformUrl_1.default)("/users/".concat(token, "/get-upload-profile-url?filename=").concat(filename)),
                })];
        });
    }); },
    getUploadProfileUrlWithFilename: function (filename) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.get({
                    mockFunc: function () { return console.log('getUploadProfileUrlWithFilename'); },
                    url: (0, combineLearningPanelFreeUrl_1.default)("/users/get-upload-profile-url?filename=".concat(filename)),
                })];
        });
    }); },
    setProfilePicture: function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.put({
                    mockFunc: function () { return console.log('setProfilePicture'); },
                    url: (0, combineLearningPanelFreeUrl_1.default)('/users/set-profile-picture'),
                    body: body,
                })];
        });
    }); },
    getUploadProfileUrlInvitation: function (token, filename) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.get({
                    mockFunc: function () { return console.log('getUploadProfileUrlInvitation'); },
                    url: (0, combinePlatformUrl_1.default)("/users/".concat(token, "/invitation/get-upload-profile-url?filename=").concat(filename)),
                })];
        });
    }); },
    uploadImage: function (signedUrl, file) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetch(signedUrl, {
                    method: 'PUT',
                    body: new Blob([file], { type: 'application/image' }),
                })];
        });
    }); },
    forgetPassword: function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.post({
                    mockFunc: function () { return console.log('forget password api'); },
                    url: (0, combinePlatformUrl_1.default)('/users/password'),
                    body: body,
                })];
        });
    }); },
    updateUserConfirmation: function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.put({
                    mockFunc: function () { return ({ json: { success: true, profile_picture_success: true } }); },
                    url: (0, combinePlatformUrl_1.default)("/users/".concat(body === null || body === void 0 ? void 0 : body.token, "/set-user-confirm")),
                    body: body,
                    returnResponse: true,
                })];
        });
    }); },
    verifyNicknameConfirmation: function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.get({
                    mockFunc: function () { return ({ json: { success: true, is_valid: true } }); },
                    url: (0, combinePlatformUrl_1.default)("/users/".concat(body === null || body === void 0 ? void 0 : body.token, "/confirmation/verify-nickname?nickname=").concat(body.nickname)),
                    body: body,
                    returnResponse: true,
                })];
        });
    }); },
    verifyNicknameInvitation: function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.get({
                    mockFunc: function () { return ({ json: { success: true, is_valid: true } }); },
                    url: (0, combinePlatformUrl_1.default)("/users/".concat(body === null || body === void 0 ? void 0 : body.token, "/invitation/verify-nickname?nickname=").concat(body.nickname)),
                    body: body,
                    returnResponse: true,
                })];
        });
    }); },
    updateUserInvitationConfirmation: function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.patch({
                    mockFunc: function () { return ({ json: { success: true, profile_picture_success: true, role: 'user' } }); },
                    url: (0, combinePlatformUrl_1.default)("/users/".concat(body === null || body === void 0 ? void 0 : body.token, "/setup-and-accept-invitation")),
                    body: body,
                    returnResponse: true,
                })];
        });
    }); },
    validateResetPasswordToken: function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.put({
                    mockFunc: function () { return ({ result: true }); },
                    url: (0, combinePlatformUrl_1.default)('/users/password/validate-token'),
                    body: body,
                })];
        });
    }); },
    resetPassword: function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.put({
                    mockFunc: function () { return ({ json: __assign(__assign({}, loginApi_1.successfulResponse), { role: 'user' }) }); },
                    url: (0, combinePlatformUrl_1.default)('/users/password/update-password-after-reset'),
                    body: body,
                    returnResponse: true,
                })];
        });
    }); },
    verifyConfirmationToken: function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.get({
                    mockFunc: function () { return loginApi_1.successfulResponse; },
                    url: (0, combinePlatformUrl_1.default)("/users/".concat(body === null || body === void 0 ? void 0 : body.token, "/confirmation/verify")),
                })];
        });
    }); },
    verifyInvitationToken: function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.get({
                    mockFunc: function () { return loginApi_1.successfulResponse; },
                    url: (0, combinePlatformUrl_1.default)("/users/".concat(body === null || body === void 0 ? void 0 : body.token, "/invitation/verify")),
                })];
        });
    }); },
    updatePassword: function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.patch({
                    mockFunc: function () { return ({ json: loginApi_1.successfulResponse }); },
                    url: (0, combineLearningPanelFreeUrl_1.default)('/users/update_password'),
                    body: body,
                    returnResponse: true,
                })];
        });
    }); },
    updateLocale: function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.patch({
                    mockFunc: function () { return ({ json: loginApi_1.successfulResponse }); },
                    url: (0, combineLearningPanelFreeUrl_1.default)('/users/update_locale'),
                    body: body,
                    returnResponse: true,
                })];
        });
    }); },
    updateNickname: function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.patch({
                    mockFunc: function () { return ({ json: loginApi_1.successfulResponse }); },
                    url: (0, combineLearningPanelFreeUrl_1.default)('/users/update_nickname'),
                    body: body,
                    returnResponse: true,
                })];
        });
    }); },
    deleteUser: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.delete({
                    mockFunc: function () { return ({ json: { status: 200 } }); },
                    url: (0, combinePlatformUrl_1.default)('/users/delete'),
                    returnResponse: true,
                })];
        });
    }); },
    deleteProfilePicture: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.delete({
                    mockFunc: function () { return loginApi_1.successfulResponse; },
                    url: (0, combineLearningPanelFreeUrl_1.default)('/users/delete-profile-picture'),
                })];
        });
    }); },
    getCreateAccountOptions: function (token) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.get({
                    mockFunc: function () { return loginApi_1.accountOptions; },
                    url: (0, combinePlatformUrl_1.default)("/users/".concat(token, "/invitation/get-create-account-options")),
                    skipErrorValidation: true,
                })];
        });
    }); },
    getCreateAccountOptionsConfirmationToken: function (token) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.get({
                    mockFunc: function () { return loginApi_1.accountOptions; },
                    url: (0, combinePlatformUrl_1.default)("/users/".concat(token, "/get-create-account-options")),
                    skipErrorValidation: true,
                })];
        });
    }); },
    getLoginStrategy: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.get({
                    mockFunc: function () { return loginApi_1.loginStrategy; },
                    url: (0, combinePlatformUrl_1.default)('/users/login-strategy'),
                    skipErrorValidation: true,
                })];
        });
    }); },
    loginWithGoogle: function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.post({
                    mockFunc: function () { return loginApi_1.notExistUserResponse; },
                    url: (0, combinePlatformUrl_1.default)('/users/google-login'),
                    body: body,
                })];
        });
    }); },
    loginWithGithub: function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetchApi_1.default.post({
                    mockFunc: function () { return loginApi_1.notExistUserResponse; },
                    url: (0, combinePlatformUrl_1.default)('/users/github-login'),
                    body: body,
                })];
        });
    }); },
};
exports.default = LoginAPI;
